/* Nyvra theme scripts */
(function () {
  'use strict';

  var cfg = window.Nyvra || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartType: 'drawer' };
  var root = cfg.routes.root.replace(/\/?$/, '/');

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Countdown (only with a real end date) ---------- */
  function initCountdown() {
    qsa('[data-countdown]').forEach(function (el) {
      var raw = (el.getAttribute('data-countdown') || '').trim().replace(' ', 'T');
      if (!raw) return;
      // Treat the date as Lima time (UTC-5) when no zone is given
      if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw += (raw.length <= 16 ? ':00' : '') + '-05:00';
      var end = new Date(raw).getTime();
      if (isNaN(end)) return;
      var clock = qs('[data-countdown-clock]', el);
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { el.hidden = true; return false; }
        var h = Math.floor(diff / 3600000), m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
        var d = Math.floor(h / 24);
        var txt = (d > 0 ? d + 'd ' + String(h % 24).padStart(2, '0') : String(h).padStart(2, '0')) + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
        clock.textContent = txt;
        el.hidden = false;
        return true;
      }
      if (tick()) {
        var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000);
      }
    });
  }

  /* ---------- Gallery ---------- */
  function initGalleries() {
    qsa('[data-gallery]').forEach(function (g) {
      if (g.dataset.init) return; g.dataset.init = '1';
      var track = qs('[data-gallery-track]', g);
      var thumbs = qsa('[data-thumb]', g);
      if (!track) return;
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.getAttribute('data-thumb'), 10);
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        });
      });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          thumbs.forEach(function (b, idx) { b.classList.toggle('is-active', idx === i); });
        });
      });
    });
  }

  function goToMedia(section, mediaId) {
    if (!mediaId) return;
    var gallery = qs('[data-gallery]', section);
    if (!gallery) return;
    var slides = qsa('[data-media-id]', gallery);
    var track = qs('[data-gallery-track]', gallery);
    slides.forEach(function (s, i) {
      if (s.getAttribute('data-media-id') === String(mediaId)) {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      }
    });
  }

  /* ---------- Product / bundle selector ---------- */
  function initProducts() {
    qsa('[data-product-section]').forEach(function (info) {
      if (info.dataset.init) return; info.dataset.init = '1';
      var section = info.closest('section') || info;
      var formId = info.getAttribute('data-form-id');
      var form = document.getElementById(formId);
      var idInput = form ? qs('[data-variant-id]', form) : null;
      var sectionId = info.getAttribute('data-section-id');
      var sticky = qs('[data-sticky-atc][data-for="' + sectionId + '"]');

      function update(data) {
        if (idInput && data.id) idInput.value = data.id;
        var price = qs('[data-price]', info);
        if (price && data.price) price.textContent = data.price;
        var compare = qs('[data-compare]', info);
        if (compare) { compare.textContent = data.compare || ''; compare.hidden = !data.compare; }
        var save = qs('[data-save]', info);
        if (save) {
          save.hidden = !data.save;
          var pct = qs('[data-save-pct]', save);
          if (pct) pct.textContent = data.save || '';
        }
        var atc = form ? qs('[data-atc]', form) : null;
        if (atc) {
          atc.disabled = !data.available;
          var lbl = qs('[data-atc-label]', atc);
          if (lbl) {
            if (!lbl.dataset.label) lbl.dataset.label = lbl.textContent;
            lbl.textContent = data.available ? lbl.dataset.label : 'Agotado';
          }
          var ap = qs('[data-atc-price]', atc);
          if (ap && data.price) ap.textContent = data.price;
        }
        if (sticky) {
          var sp = qs('[data-sticky-price]', sticky);
          if (sp && data.price) sp.textContent = data.price;
        }
        var stock = qs('[data-stock]', info);
        if (stock) {
          var th = parseInt(stock.getAttribute('data-threshold'), 10) || 0;
          var inv = data.inventory === '' || data.inventory == null ? null : parseInt(data.inventory, 10);
          if (inv !== null && inv > 0 && inv <= th) {
            qs('[data-stock-count]', stock).textContent = inv;
            stock.hidden = false;
          } else {
            stock.hidden = true;
          }
        }
        if (data.media) goToMedia(section, data.media);
        if (data.id && document.body.classList.contains('template-product')) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', data.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* ignore */ }
        }
      }

      qsa('[data-bundle] input[type="radio"]', info).forEach(function (radio) {
        radio.addEventListener('change', function () {
          qsa('[data-bundle] .bundle__opt', info).forEach(function (l) { l.classList.remove('is-selected'); });
          radio.closest('.bundle__opt').classList.add('is-selected');
          update({
            id: radio.value,
            price: radio.getAttribute('data-price'),
            compare: radio.getAttribute('data-compare'),
            save: radio.getAttribute('data-save'),
            available: radio.getAttribute('data-available') === 'true',
            inventory: radio.getAttribute('data-inventory'),
            media: radio.getAttribute('data-media')
          });
        });
      });

      var select = qs('[data-variant-select]', info);
      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          update({ price: opt.getAttribute('data-price'), available: !opt.disabled });
        });
      }

      // Quantity +/-
      qsa('[data-qty]', info).forEach(function (q) {
        var input = qs('input', q);
        var minus = qs('[data-qty-minus]', q), plus = qs('[data-qty-plus]', q);
        if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
        if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      });

      // Sticky add to cart
      if (sticky && form) {
        var atcBtn = qs('[data-atc]', form);
        var stickyBtn = qs('[data-sticky-btn]', sticky);
        var isProductPage = document.body.classList.contains('template-product');
        if ('IntersectionObserver' in window && atcBtn) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              var show = !e.isIntersecting && window.scrollY > 480;
              sticky.classList.toggle('is-visible', show);
              sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
              stickyBtn.tabIndex = show ? 0 : -1;
              document.body.classList.toggle('has-sticky-atc', show);
            });
          }, { rootMargin: '0px 0px -40px 0px' });
          io.observe(atcBtn);
          window.addEventListener('scroll', function () {
            if (window.scrollY <= 480 && sticky.classList.contains('is-visible')) {
              sticky.classList.remove('is-visible');
              sticky.setAttribute('aria-hidden', 'true');
              document.body.classList.remove('has-sticky-atc');
            }
          }, { passive: true });
          var rect = function () { return atcBtn.getBoundingClientRect(); };
          window.addEventListener('scroll', function () {
            var r = rect();
            var offscreen = r.bottom < 0 || r.top > window.innerHeight;
            var show = offscreen && window.scrollY > 480;
            if (show !== sticky.classList.contains('is-visible')) {
              sticky.classList.toggle('is-visible', show);
              sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
              stickyBtn.tabIndex = show ? 0 : -1;
              document.body.classList.toggle('has-sticky-atc', show);
            }
          }, { passive: true });
        }
        stickyBtn.addEventListener('click', function () {
          if (isProductPage && atcBtn && !atcBtn.disabled) {
            if (form.requestSubmit) form.requestSubmit(atcBtn); else atcBtn.click();
          } else {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = null;
  var lastFocus = null;

  function drawerEnabled() { return cfg.cartType === 'drawer' && !!qs('[data-cart-drawer]'); }

  function openDrawer() {
    drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var panel = qs('.drawer__panel', drawer);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }

  function closeDrawer() {
    drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('[data-cart-inner]', doc);
    var current = qs('[data-cart-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function updateCount() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        qsa('[data-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Carrito, ' + cart.item_count + ' productos'); });
      })
      .catch(function () {});
  }

  function changeLine(line, qty) {
    var d = qs('[data-cart-drawer]');
    if (d) d.classList.add('is-loading');
    return fetch(cfg.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.sections) renderDrawer(res.sections['cart-drawer']);
        return updateCount();
      })
      .finally(function () { if (d) d.classList.remove('is-loading'); });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && drawerEnabled() && !document.body.classList.contains('template-cart')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var lineBtn = e.target.closest('[data-cart-drawer] [data-line]');
      if (lineBtn) {
        changeLine(parseInt(lineBtn.getAttribute('data-line'), 10), parseInt(lineBtn.getAttribute('data-qty'), 10));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('drawer-open')) closeDrawer();
    });

    // Ajax add to cart
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (!drawerEnabled()) return;
      e.preventDefault();
      var btn = e.submitter || qs('[type="submit"]', form);
      var err = qs('[data-form-error]', form);
      if (err) err.hidden = true;
      if (btn) btn.classList.add('is-loading');
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      fetch(cfg.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || res.body.status) {
            var msg = res.body.description || res.body.message || 'No pudimos agregar el producto. Intenta de nuevo.';
            if (err) { err.textContent = msg; err.hidden = false; }
            return;
          }
          if (res.body.sections) renderDrawer(res.body.sections['cart-drawer']);
          updateCount();
          openDrawer();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Mobile menu: close on outside click ---------- */
  function initMenu() {
    var m = qs('[data-mnav]');
    if (!m) return;
    document.addEventListener('click', function (e) {
      if (m.open && !m.contains(e.target)) m.open = false;
    });
    qsa('a', m).forEach(function (a) { a.addEventListener('click', function () { m.open = false; }); });
  }

  function init() {
    initCountdown();
    initGalleries();
    initProducts();
    initCart();
    initMenu();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init inside the theme editor when sections reload
  document.addEventListener('shopify:section:load', function () { initGalleries(); initProducts(); initCountdown(); });
})();
